import script from "./AtomButtonIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomButtonIcon.vue?vue&type=script&lang=ts&setup=true"

import "./AtomButtonIcon.vue?vue&type=style&index=0&id=8f6af5a4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f6af5a4"]])

export default __exports__